import { XIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { EscrowAlertBadge } from 'src/components/Escrow/AlertBadge';
import { cn } from 'src/lib/utils';

import { useEscrowDashboardCard } from '../model/context';

import { ContentWrapper } from './ContentWrapper';
import { Parties } from './Parties';

const Rejected = () => {
  const { viewModel, config } = useEscrowDashboardCard();
  const { onRemove } = viewModel;
  const { statusMap } = config;

  const rejected = statusMap.rejected;
  if (!rejected) return null;

  const { label, bgColor, color } = rejected;

  return (
    <Card>
      <ContentWrapper>
        <div className="p-4 sm:p-6 flex flex-col justify-between h-full bg-muted/40">
          <div className="flex items-start justify-between gap-2 mb-5">
            <div className="flex items-center gap-2">
              <EscrowAlertBadge variant="alert" className="size-5" iconClassName="size-4.5" />
              <Badge className={cn('shadow-sm rounded', bgColor, color)}>{label}</Badge>
            </div>
            <Button variant="ghost" size="icon" className="size-6" onClick={onRemove}>
              <XIcon className="size-4" />
            </Button>
          </div>
          <Parties />
          <div className="text-xs space-y-0.5">
            <strong className="font-semibold text-gray-500">The invitation to this escrow was declined.</strong>
            <p className="text-gray-400">Please delete this escrow and start a new one if needed.</p>
          </div>
        </div>
      </ContentWrapper>
    </Card>
  );
};

export { Rejected };
